import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/monero': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M352 384H460.4C417 455.9 338.1 504 248 504S79 455.9 35.6 384H144V256.2L248 361 352 256V384zM88 336V128L247.4 287.4 408 128V336H482.8C491.3 310.9 496 284 496 256 496 119 385 8 248 8S0 119 0 256C0 284 4.6 310.9 13.2 336H88z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/monero.js
// module id = zBVY
// module chunks = 144